module.exports = __webpack_public_path__ + "static/notting-hill-interiors-e7c8c75336d0efb3a0687a0117bd2426.png";